import { render, staticRenderFns } from "./NewEditFranquiaPage.vue?vue&type=template&id=e5e5fc6a&scoped=true"
import script from "./NewEditFranquiaPage.vue?vue&type=script&lang=js"
export * from "./NewEditFranquiaPage.vue?vue&type=script&lang=js"
import style0 from "./NewEditFranquiaPage.vue?vue&type=style&index=0&id=e5e5fc6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5e5fc6a",
  null
  
)

export default component.exports